import { gql } from '@apollo/client'
import React from 'react'

import { integrationsClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import { useTrigger } from './TriggerLoader'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useIntegrationState = () => React.useContext(Context)
export const useIntegration = () => useIntegrationState()?.integration

const QUERY = gql`
  query Integration($id: ID) {
    integration(id: $id) {
      id
      service
      extraData
    }
  }
`

const IntegrationLoader = ({ children }) => {
  const { initialState } = useModalData()
  const trigger = useTrigger()
  const id = trigger?.integrationId || initialState?.integrationId

  const { data, ...state } = useQuery(QUERY, {
    skip: !id,
    variables: { id },
    client: integrationsClient,
    fetchPolicy: 'cache-first'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default IntegrationLoader
